import { RootState } from '../../store';

export const getChecksSelector = (state: RootState) => state?.roleReducer?.checks;
